import React from "react";

import ModelCompare from "views/ModelCompare";

const SingleTrim = props => <ModelCompare trimSize={1} {...props} />;

export default SingleTrim;
